import { useEffect } from 'react';

export default function HomeSEO() {
  useEffect(() => {
    document.title = '饭岛爱——传奇人生与永恒影响力 | 饭岛爱纪念网';
    
    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '饭岛爱，日本娱乐界最具传奇色彩的女性之一，从AV女优到畅销作家、电视主持人，她的人生轨迹震撼了整个时代。本页全面回顾饭岛爱的成长历程、代表作品、社会影响及她留给世界的深刻印记。');
    setMeta('keywords', '饭岛爱,饭岛爱自传,饭岛爱白书,饭岛爱人生经历,饭岛爱影响力,饭岛爱作品,日本传奇女性');
    setMeta('og:title', '饭岛爱——传奇人生与永恒影响力', true);
    setMeta('og:description', '全面回顾饭岛爱的传奇人生与永恒影响力', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://iijima-ai-memorial.com/', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', '饭岛爱——传奇人生与永恒影响力');
    setMeta('twitter:description', '全面回顾饭岛爱的传奇人生与永恒影响力');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://iijima-ai-memorial.com/');

    const existingScript = document.getElementById('home-jsonld');
    if (existingScript) existingScript.remove();

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '饭岛爱纪念网',
      url: 'https://iijima-ai-memorial.com',
      description: '全面回顾饭岛爱的传奇人生与永恒影响力',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://iijima-ai-memorial.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    };

    const script = document.createElement('script');
    script.id = 'home-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }, []);

  return null;
}